import { render, staticRenderFns } from "./ShiftManagement.vue?vue&type=template&id=5350d7b1&scoped=true"
import script from "./ShiftManagement.vue?vue&type=script&lang=js"
export * from "./ShiftManagement.vue?vue&type=script&lang=js"
import style0 from "./ShiftManagement.vue?vue&type=style&index=0&id=5350d7b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350d7b1",
  null
  
)

export default component.exports